"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./Inboxitem.module.css";
import moment from "moment";

// const _interactionsData = JSON.parse(
//   '{"events":{"e-827":{"id":"e-827","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-38","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-828"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fcf9754d-67c5-442e-199a-421324264520","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fcf9754d-67c5-442e-199a-421324264520","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721144570309},"e-828":{"id":"e-828","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-827"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fcf9754d-67c5-442e-199a-421324264520","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fcf9754d-67c5-442e-199a-421324264520","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721144570309},"e-829":{"id":"e-829","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-56","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-830"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fcf9754d-67c5-442e-199a-421324264511","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fcf9754d-67c5-442e-199a-421324264511","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721144597643},"e-830":{"id":"e-830","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-57","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-829"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fcf9754d-67c5-442e-199a-421324264511","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fcf9754d-67c5-442e-199a-421324264511","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721144597646}},"actionLists":{"a-38":{"id":"a-38","title":"template options [show]","actionItemGroups":[{"actionItems":[{"id":"a-38-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".options-popup","selectorGuids":["70df4d13-8b09-939e-160b-d10041c795ea"]},"value":"block"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702910603861},"a-39":{"id":"a-39","title":"template options [hide]","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".options-popup","selectorGuids":["70df4d13-8b09-939e-160b-d10041c795ea"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702910603861},"a-56":{"id":"a-56","title":"option div [show]","actionItemGroups":[{"actionItems":[{"id":"a-56-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".timenotification","selectorGuids":["d0be99c9-a174-ff15-bc52-decce2ac218b"]},"value":"none"}},{"id":"a-56-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".optiondiv","selectorGuids":["785a1c26-3c88-4b7b-ba6c-6a49b48eb728"]},"value":"block"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721144600326},"a-57":{"id":"a-57","title":"option div [hide]","actionItemGroups":[{"actionItems":[{"id":"a-57-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".timenotification","selectorGuids":["d0be99c9-a174-ff15-bc52-decce2ac218b"]},"value":"flex"}},{"id":"a-57-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".optiondiv","selectorGuids":["785a1c26-3c88-4b7b-ba6c-6a49b48eb728"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721144626932}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
// );

export function Inboxitem({
  as: _Component = _Builtin.Block,
  avatar = "images/66968578d5889c78730e31f3_avatar_01.png",
  username = "Albert Flores",
  textpreview = "Hi Pat, it was a pleasure to..",
  time = "09:20",
  handleClickUserInbox = () => { },
  item,
  currentLead,
  ...props
}) {
  // _interactions.useInteractions(_interactionsData, _styles);
  time = item.time;
  username = props.name;
  textpreview = item.textpreview;
  return (
    <_Component
      className={_utils.cx(_styles, "inbox-item")}
      style={{ backgroundColor: currentLead.id === item.id ? "#eeeffe" : "" }}
      data-w-id="fcf9754d-67c5-442e-199a-421324264511"
      tag="div"
      onClick={() => handleClickUserInbox(item)}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "inboxlist_left")}
        tag="div"
      >
        <_Builtin.Block className={_utils.cx(_styles, "avatar")} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, "avatar_image")}
            width="auto"
            height="auto"
            loading="lazy"
            alt=""
            src={avatar}
          />
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "inboxtextcontent")}
          tag="div"
        >
          <_Builtin.Block className={_utils.cx(_styles, "username")} tag="div">
            {username}
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "previewtext")}
            tag="div"
          >
            {textpreview}
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "inboxlist_right")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "timenotification")}
          tag="div"
        >
          <_Builtin.Block className={_utils.cx(_styles, "timetext")} tag="div">
            {moment(time).format("h:mm a")}
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "notification-dot")}
            tag="div"
            style={{ display: item && item.channelInfo?.unreadCount != 0 ? 'flex' : 'none' }}
          />
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, "optiondiv")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "template-options")}
            data-w-id="fcf9754d-67c5-442e-199a-421324264520"
            tag="div"
          >
            <_Builtin.Image
              width="auto"
              height="auto"
              loading="lazy"
              alt=""
              src="images/66968578d5889c78730e31aa_icon_threedots.svg"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "options-popup")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "options-item")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "icon-small")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31f4_Asset_8.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Edit"}</_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "options-item")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "icon-small")}
                  tag="div"
                >
                  <_Builtin.Image
                    width="auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="images/66968578d5889c78730e31f7_Asset_9.svg"
                  />
                </_Builtin.Block>
                <_Builtin.Block tag="div">{"Remove"}</_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
